import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import useConceptConfiguration from '../ConceptCalculation/useConceptConfiguration'
import Headline from '../../../../UI/Headline/Headline'
import BarStacked, { GraphValue, Item } from '../../../../UI/Chart/BarStacked/BarStacked'
import { Concept } from '../../../../../types/Survey/Analysis/Concept'
import getSums from '../ConceptCalculation/OrganizationUnit/SurveyResults/getSums'

const Graph: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { context, concepts, graphConceptUUIDList, activeConceptUUID, setActiveConcept } = useConceptConfiguration()
  const enableScreenshotMode = useSelector((s) => s[props.ENABLE_SCREENSHOT_MODE])

  const getConceptValues = (concept: Concept): GraphValue[] => {
    const sums = getSums(concept.units.sum)

    const items = [
      {
        label: t.survey.analysis.calculation.values.arbeitsplaetze.headline,
        value:
          concept.units.sum.EINZELARBEIT.KLASSISCHE_ARBEIT.practicalQM +
          sums.einzelbueros +
          concept.units.sum.EINZELARBEIT.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR.practicalQM,
      },
      {
        label: t.survey.analysis.calculation.values.arbeitsorte.headline,
        value: sums.kommunikation + sums.kollaboration + concept.units.sum.EINZELARBEIT.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR.practicalQM,
      },
      {
        label: t.survey.analysis.calculation.values.uebergeordneteBedarfe.headline,
        value: sums.uebergeordneteBedarfe,
      },
      {
        label: t.survey.analysis.calculation.values.sonderbedarfe.headline,
        value: sums.sonderbedarfe,
      },
      {
        label: t.survey.analysis.calculation.values.stauflaeche.headline,
        value: sums.staufleache,
      },
      {
        label: t.survey.analysis.calculation.values.verkehrsflaechen.headline,
        value: sums.verkehrsflaechen,
      },
    ]

    return items
  }

  const getItems = (): Item[] => {
    if (!concepts) return []
    return concepts
      .filter((c) => graphConceptUUIDList.includes(c.uuid))
      .map((concept) => {
        return {
          key: concept.uuid,
          label: concept.name,
          values: getConceptValues(concept),
          isActive: activeConceptUUID === concept.uuid,
        }
      })
  }

  if (getItems().length === 0) return null
  return (
    <div>
      <Headline text={t.survey.analysis.concept.graph.headline} />
      <BarStacked
        useTransparentColors={!enableScreenshotMode}
        items={getItems()}
        suffix={t.generic.squareMeterSuffix}
        showGrid={true}
        onClickCallback={setActiveConcept}
        redLineValue={context.floors?.reduce((acc, floor) => acc + floor.squareMeter, 0) || 0}
        enableDownload
        showLegend
      />
    </div>
  )
}

export default Graph
